import { useNavigate, useLocation } from "react-router-dom";
import { SegmentedControl, Segment } from "@conuti-das/prince-ui";

/**
 * Sub-nav for the Validator section. Switches between the validation
 * workflow page and the conditions-overview maintenance page without
 * leaving the "Validator" top-level tab.
 */
export function ValidatorSubNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const onConditions = pathname.startsWith("/validator/conditions");

  return (
    <div style={{ marginBottom: "var(--s-3)" }}>
      <SegmentedControl
        aria-label="Validator-Bereich"
        selectedKeys={new Set([onConditions ? "conditions" : "validate"])}
        onSelectionChange={(keys) => {
          const first = [...keys][0];
          if (first === "conditions") navigate("/validator/conditions");
          else navigate("/validator");
        }}
      >
        <Segment id="validate">Validieren</Segment>
        <Segment id="conditions">Conditions-Übersicht</Segment>
      </SegmentedControl>
    </div>
  );
}
